import hogan from 'hogan.js';

const filterOutput = output => {
	return output.filter(x => typeof x ==='string'); // eslint-disable-line
};

const mapIt = (data, template) => {
	return data.map(item => template.render(item));
};

export const build = (template, data, container, callback) => {
	const output = mapIt(data, template);
	const clear = filterOutput(output);
	return () => callback(container, clear);
};

export const compile = elem => {
	return hogan.compile(elem.innerHTML);
};


